import gql from 'graphql-tag';

const CREATE_BLOG = gql`
    mutation createBlog($location: [String!]!, $title: String!, $content: String!, $email: String!, $image: Upload) {
        createBlog(location: $location, title: $title, content: $content, email: $email, image: $image) {
            blog {
            id
            title
            content
            readTime
            }
            error
        }
    }
`

const FIND_BLOG = gql`
    query findBlog($blogId: ID, $blogTitle: String, $city: String!) {
        findBlog(blogId: $blogId, blogTitle: $blogTitle, city: $city) {
            id
            title
            content
            readTime
            imageUrl
            publicationDate
            lastEditedBy
            lastEditedAt
            publisher
            urlTitle
            comments{
                id
                body
                commentedAt
                commentedBy
                parentComment{
                    id
                }
                replies{
                    id
                    body
                    commentedAt
                    commentedBy
                }
            }
            cities {
                name
            }
        }
    }
`

const GET_ALL_BLOGS = gql`
    query getAllBlogs($city: String!) {
        getAllBlogs(city: $city) {
            id
            title
            readTime
            content
            publicationDate
            imageUrl
            urlTitle
            comments {
                id
            }
        }
    }
`

const ADD_BLOG_COMMENT = gql`
    mutation addBlogComment($commenterId: ID!, $commenterType: String!, $blogId: ID!, $content: String!) {
        addBlogComment(commenterId: $commenterId, commenterType: $commenterType, blogId: $blogId, content: $content) {
            blogComment {
            id
            blogId
            commentedAt
            commentedBy
            parentComment {
                id
                blogId
            }
            replies {
                id
                blogId
            }
            }
        }
    }
`

const REPLY_TO_BLOG_COMMENT = gql `
    mutation replyToBlogComment($replierId: ID!, $replierType: String!, $commentId: ID!, $content: String!) {
        replyToBlogComment(replierId: $replierId, replierType: $replierType, commentId: $commentId, content: $content){
            blogComment {
            id
            blogId
            commentedAt
            commentedBy
            parentComment {
                id
                blogId
            }
            replies {
                id
                blogId
            }
            }
            error
        }
    }
`

const EDIT_BLOG = gql`
    mutation editBlog($id: ID!, $adminId: ID!, $title: String, $content: String, $image: Upload, $locations: [String!]) {
        editBlog(id: $id, adminId: $adminId, title: $title, content: $content, image: $image, locations: $locations) {
            blog {
            id
            title
            content
            imageUrl
            cities {
                name
            }
            lastEditedBy
            lastEditedAt
            }
        }
    }
`

const DELETE_BLOG = gql`
    mutation deleteBlog($id: ID!) {
        deleteBlog(id: $id) {
            success
            error
        }
    }
`

const DELETE_BLOG_COMMENT = gql`
    mutation deleteBlogComment($commentId: ID!) {
        deleteBlogComment(commentId: $commentId) {
            success
            error
        }
    }
`

const REPORT_BLOG_COMMENT = gql`
    mutation reportBlogComment($commentId: ID!, $adminId: ID!) {
        reportBlogComment(commentId: $commentId, adminId: $adminId) {
            success
            error
        }
    }
`

const BLOCK_USER = gql`
    mutation blockUser($userId: ID!) {
        blockUser(userId: $userId) {
            success
            error
        }
    }
`

export {GET_ALL_BLOGS, FIND_BLOG, CREATE_BLOG, ADD_BLOG_COMMENT, DELETE_BLOG_COMMENT, EDIT_BLOG, DELETE_BLOG, REPORT_BLOG_COMMENT, REPLY_TO_BLOG_COMMENT, BLOCK_USER}



// WEBPACK FOOTER //
// ./src/components/Blogs/queries.js